import { useEffect } from 'react';
import { useMutation } from 'react-apollo';

import { toastMapping } from 'components/ErrorBoundary/ErrorBoundary';
import { getGraphQLError } from 'helpers/getGraphQLError';

import PROCESS_EXPORT_REPORTS_DATA from './AsyncReport.queries';

const defaultError = {
  displayMessage: `Something went wrong.`,
  message: `We were not able to generate the reports.`,
};

export const useAsyncReport = () => {
  const [processExportReportsData, { data, loading, error }] = useMutation(
    PROCESS_EXPORT_REPORTS_DATA,
  );

  useEffect(() => {
    if (!data && loading) {
      toastMapping(
        {},
        'success',
      )([
        {
          displayMessage: 'Generating Report',
          message: 'You will get an email when this report is ready',
        },
      ]);
    }

    if (error) {
      const formattedError = getGraphQLError(defaultError, false, error);

      toastMapping({}, 'error')(formattedError);
    }
  }, [data, loading, error]);

  return processExportReportsData;
};
